var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-bottom"},[_c('span',[_vm._v(" © 2009-"+_vm._s(this.year)+" 大树联合集团 Powered By "),_c('a',{attrs:{"href":"http://www.xiaoxxx.com/"}},[_vm._v("小仙科技")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b2dfd8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashu/backfooter.vue
// module id = null
// module chunks = 